// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    display: flex;
    flex-direction: column;
    align-items:start;
    gap: 10px; 
}
  .subMenuTitle {
    font-family: Elevance Sans;
    color: #666666;
    font-size: 20px;
    font-weight: 500 !important;
    margin-left: 4px;
    font-size: 20px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-align: left;
  }

  .subMenuTitleSelected {
    font-family: Elevance Sans;
    color: #286CE2;
    font-size: 20px; 
    font-weight: 600;
    margin-left: 4px;
    line-height: 30px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-align: left;
  }

  .menuTitle {
    font-family: Elevance Sans;
    color: #333333;
    font-weight: 600;
    line-height: 30px;
    margin-left: 0px;
    font-size: 20px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    text-align: left;
  }

  .menu {
    font-family: Elevance Sans;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    text-align: left;
    color: #333333;
    ;

  }`, "",{"version":3,"sources":["webpack://./client/components/Header/MobileDrawer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;AACb;EACE;IACE,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;;;EAGhB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    align-items:start;\n    gap: 10px; \n}\n  .subMenuTitle {\n    font-family: Elevance Sans;\n    color: #666666;\n    font-size: 20px;\n    font-weight: 500 !important;\n    margin-left: 4px;\n    font-size: 20px;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    text-align: left;\n  }\n\n  .subMenuTitleSelected {\n    font-family: Elevance Sans;\n    color: #286CE2;\n    font-size: 20px; \n    font-weight: 600;\n    margin-left: 4px;\n    line-height: 30px;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    text-align: left;\n  }\n\n  .menuTitle {\n    font-family: Elevance Sans;\n    color: #333333;\n    font-weight: 600;\n    line-height: 30px;\n    margin-left: 0px;\n    font-size: 20px;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    text-align: left;\n  }\n\n  .menu {\n    font-family: Elevance Sans;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 24px;\n    text-align: left;\n    color: #333333;\n    ;\n\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
